/* eslint-disable max-len */
import { createAction } from 'redux-actions';

import {
	CLEAR_ATTENDANCE_RECORDS,
	GET_ATTENDANCE_HISTORY_CALL,
	GET_ATTENDANCE_HISTORY_DONE,
	GET_ATTENDANCE_HISTORY_FAIL,
	DELETE_PUNCH_IN_RECORD_CALL,
	DELETE_PUNCH_IN_RECORD_DONE,
	DELETE_PUNCH_IN_RECORD_FAIL,
	GET_PUNCH_IN_RECORDS_CALL,
	GET_PUNCH_IN_RECORDS_DONE,
	GET_PUNCH_IN_RECORDS_FAIL,
	PUT_PUNCH_IN_RECORD_CALL,
	PUT_PUNCH_IN_RECORD_DONE,
	PUT_PUNCH_IN_RECORD_FAIL,
} from '@src/store/types';

export const clearAttendanceRecords = createAction(CLEAR_ATTENDANCE_RECORDS);

export const getAttendanceHistoryCall = createAction(GET_ATTENDANCE_HISTORY_CALL);
export const getAttendanceHistoryDone = createAction(GET_ATTENDANCE_HISTORY_DONE);
export const getAttendanceHistoryFail = createAction(GET_ATTENDANCE_HISTORY_FAIL);

export const deletePunchInRecordCall = createAction(DELETE_PUNCH_IN_RECORD_CALL);
export const deletePunchInRecordDone = createAction(DELETE_PUNCH_IN_RECORD_DONE);
export const deletePunchInRecordFail = createAction(DELETE_PUNCH_IN_RECORD_FAIL);

export const getPunchInRecordsCall = createAction(GET_PUNCH_IN_RECORDS_CALL);
export const getPunchInRecordsDone = createAction(GET_PUNCH_IN_RECORDS_DONE);
export const getPunchInRecordsFail = createAction(GET_PUNCH_IN_RECORDS_FAIL);

export const putPunchInRecordCall = createAction(PUT_PUNCH_IN_RECORD_CALL);
export const putPunchInRecordDone = createAction(PUT_PUNCH_IN_RECORD_DONE);
export const putPunchInRecordFail = createAction(PUT_PUNCH_IN_RECORD_FAIL);
